module.exports = __webpack_public_path__ + "img/MIS.58bf3cb2.svg";